import ClearanceCertificateQuickQuote from './ClearanceCertificateQuickQuote'

export default ClearanceCertificateQuickQuote
